var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "419px",
    height: "243px",
    viewBox: "0 0 419 243",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MD / Vector / Ideas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.4318313,32.611278 C58.4318313,32.611278 33.8180933,-5.46108853 3.95614676,0.667853183 C-17.50106,59.0021913 55.3183346,90.3651898 55.3183346,90.3651898 L58.4318313,32.611278",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5469207,74.7169456 C43.5469207,74.7169456 85.1112515,38.2519902 71.722515,0.0527491451 C1.9996035,-2.16505861 -5.68890387e-14,66.2892762 -5.68890387e-14,66.2892762 L43.5469207,74.7169456",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4318766,32.611278 C58.4318766,32.611278 33.8181386,-5.46108853 3.95619203,0.667853183 C-17.5010147,59.0021913 55.317379,90.3651898 55.317379,90.3651898 L58.4318766,32.611278",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5469207,74.7169456 C43.5469207,74.7169456 85.1112515,38.2519902 71.722515,0.0527491451 C1.9996035,-2.16505861 -5.68890387e-14,66.2892762 -5.68890387e-14,66.2892762 L43.5469207,74.7169456",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250126898,22.2961597 C-3.41381125,38.1914476 34.1413045,40.2354272 49.6157136,40.4082564 C53.907155,40.456209 58.1745771,40.0496109 62.3809502,39.1984522 C75.4664436,36.548072 104.111414,29.590949 100.093192,20.1332976 C94.9100356,7.92936086 79.3405502,16.4379503 79.3405502,16.4379503 C79.3405502,16.4379503 81.2941168,7.22505704 54.79887,1.13907287 C28.3056249,-4.94591229 28.4107091,15.3310445 28.4107091,15.3310445 C28.4107091,15.3310445 4.85281784,2.32589972 0.250126898,22.2961597",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.33913629e-05%",
    y1: "50.0004938%",
    x2: "100.0005%",
    y2: "50.0004938%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.78993894,32.6136109 C2.11388105,29.319932 3.93811975,8.7336245 0,0.544711286 C0.0921011876,0.364878374 0.17912093,0.183090755 0.264235131,0 C4.68191624,8.4892863 2.48673207,30.6439193 2.24155235,32.9674126 C2.09419045,32.8462209 1.94111193,32.7308932 1.78993894,32.6136109",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.003033%",
    y1: "49.9990118%",
    x2: "-1104.29624%",
    y2: "49.9990118%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-15",
    points: "7.8997599 1.70017277 8.00642042 3.99605001 0 2.50131479 1.67835491 0 7.8997599 1.70017277"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.991942%",
    x2: "99.9965621%",
    y2: "49.991942%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MD-/-Vector-/-Ideas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.980376,110.589884 L205.02955,119.679899 C205.049431,123.085532 202.834655,125.884765 200.11047,125.89975 L184.631057,125.98372 C181.906873,125.997654 179.663073,123.223396 179.644058,119.817762 L179.595019,110.727747 L204.980376,110.589884",
    id: "Fill-3",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#21837F",
    points: "198.510187 125.908741 196.782802 130.070628 187.156082 130.122576 185.028376 125.98067 198.510187 125.908741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.753967,121.546054 C190.753967,121.546054 166.140229,83.4736874 136.278283,89.6026291 C114.821076,147.936967 187.640471,179.299966 187.640471,179.299966 L190.753967,121.546054",
    id: "Fill-9",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(132.322136, 88.934776)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-10",
    fill: "#21837F",
    mask: "url(#mask-2)",
    points: "6.7553915 49.3687137 40.9277947 50.187904 3.47976474 1.03049472 4.43352957 0.306210656 27.1617556 30.1407201 30.4513935 5.02954177 31.5242539 6.05952366 28.1925822 31.493383 59.0223048 71.9643785 58.06854 72.6876636 41.8555386 51.4057002 7.8142406 50.590506 6.7553915 49.3687137"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.56408,168.61253 C224.56408,168.61253 266.128411,132.147575 252.739674,93.9483335 C183.016763,91.7305257 181.017159,160.18486 181.017159,160.18486 L224.56408,168.61253",
    id: "Fill-13",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(181.017159, 93.895584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#FFFFFE",
    mask: "url(#mask-4)",
    points: "25.1381585 13.0998524 26.2700662 12.4295151 32.0046648 53.1972173 74.9821289 3.73411022 75.898864 4.52832516 45.4124166 39.6156423 69.3085792 42.627665 68.0946057 43.6966084 44.4546486 40.7175531 19.7088047 69.1974016 18.2055992 69.0795181 30.9488181 54.4120165 25.1381585 13.0998524"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#21837F",
    points: "125.488631 146.157726 256.869986 146.157726 256.869986 128.678004 125.488631 128.678004"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#005C5A",
    points: "250.383785 146.157726 230.489832 237.602335 153.937444 237.602335 132.450213 146.157726 250.383785 146.157726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.689004,110.789686 L367.110389,110.651823 C367.110389,110.651823 365.174837,102.933452 365.899418,97.0063107 C366.174639,94.7665247 367.53473,92.7854829 369.451266,91.5886659 C394.367247,76.0390363 388.258348,58.276594 388.258348,58.276594 C388.258348,58.276594 385.547174,35.7258848 353.521492,33.7138736 C319.379113,31.5689937 321.585883,61.8420696 321.585883,61.8420696 C321.585883,61.8420696 320.118706,78.6994066 337.891959,90.0461906 C340.433997,91.6685869 342.049293,94.4078792 342.431599,97.3959256 C343.39337,104.901507 341.689004,110.789686 341.689004,110.789686",
    id: "Fill-19",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.110389,110.589884 L367.159563,119.679899 C367.179445,123.085532 364.964669,125.884765 362.240484,125.89975 L346.76007,125.98372 C344.036886,125.997654 341.793087,123.223396 341.774072,119.817762 L341.725032,110.727747 L367.110389,110.589884",
    id: "Fill-20",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#21837F",
    points: "360.640201 125.908741 358.912816 130.070628 349.286096 130.122576 347.15839 125.98067 360.640201 125.908741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.546135,69.9730324 C363.592568,72.8861529 360.469063,73.7193293 357.231467,73.459586 L357.202376,67.9240577 C357.196439,66.8950749 357.590755,65.9040545 358.32034,65.1777724 C359.624386,63.8820532 361.94925,62.511408 364.837567,63.949986 C366.656025,65.069879 366.873199,67.9919906 365.546135,69.9730324 Z M349.879572,71.8042223 C347.426605,71.0050123 343.956822,69.3696288 343.620553,66.9320383 C343.539488,66.3376259 343.797695,65.7262302 344.245053,65.3236282 C348.524485,61.4564508 349.819524,68.3856015 349.801509,69.2547424 C349.892582,70.0929139 349.888579,70.9500666 349.879572,71.8042223 Z M367.032327,70.259749 C370.859396,63.0548708 361.334758,59.5423428 356.864173,64.4864557 C356.055524,65.3805719 355.696236,66.5923741 355.679222,67.7971832 C355.648198,69.9310739 355.696236,73.2547885 355.696236,73.2547885 C354.346153,73.0300107 352.84495,72.6833533 351.705036,72.3556772 C351.750072,70.2947144 351.716044,68.1658188 351.109558,66.3955686 C348.419401,58.5343392 338.316299,64.6752691 344.245053,70.2757332 C345.632166,71.5854386 347.673803,72.5614738 349.873567,73.2627806 C350.046706,85.7104764 350.219845,98.1591712 350.392983,110.606867 L352.130377,110.596877 C352.023291,102.946439 351.917206,95.2950023 351.81012,87.6435656 C351.755076,83.6734899 351.699031,79.7034142 351.643987,75.7333385 C351.63598,75.1099547 351.650992,74.4456114 351.669007,73.7672819 C352.968048,74.0819708 354.263087,74.3027526 355.50108,74.4336232 L355.697237,110.577896 L357.433629,110.568904 L357.237472,74.5624958 C357.588754,74.576482 357.950043,74.5974613 358.275304,74.5944642 C361.577953,74.5694889 365.385006,73.3616828 367.032327,70.259749 L367.032327,70.259749 Z",
    id: "Fill-22",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.883981,121.546054 C352.883981,121.546054 328.270243,83.4736874 298.408296,89.6026291 C276.95109,147.936967 349.769483,179.299966 349.769483,179.299966 L352.883981,121.546054",
    id: "Fill-23",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(294.452104, 88.934776)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-24",
    fill: "#21837F",
    mask: "url(#mask-6)",
    points: "6.75643757 49.3687137 40.9278399 50.187904 3.47981001 1.03049472 4.43357485 0.306210656 27.1608 30.1407201 30.4514388 5.02954177 31.5242991 6.05952366 28.1926275 31.493383 59.0223501 71.9643785 58.0685853 72.6876636 41.8555839 51.4057002 7.81328507 50.590506 6.75643757 49.3687137"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.694094,168.61253 C386.694094,168.61253 428.258424,132.147575 414.869688,93.9483335 C345.146776,91.7305257 343.147173,160.18486 343.147173,160.18486 L386.694094,168.61253",
    id: "Fill-27",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(343.147173, 93.895584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-28",
    fill: "#FFFFFE",
    mask: "url(#mask-8)",
    points: "25.1381585 13.0998524 26.2700662 12.4295151 32.0046648 53.1972173 74.9821289 3.73411022 75.898864 4.52832516 45.4124166 39.6156423 69.3085792 42.627665 68.0946057 43.6966084 44.4546486 40.7175531 19.7088047 69.1974016 18.2055992 69.0795181 30.9488181 54.4120165 25.1381585 13.0998524"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#21837F",
    points: "287.618644 146.157726 419 146.157726 419 128.678004 287.618644 128.678004"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-32",
    fill: "#005C5A",
    points: "412.513799 146.157726 392.619846 237.602335 316.066457 237.602335 294.580227 146.157726 412.513799 146.157726"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-167",
    transform: "translate(185.294663, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250126898,22.2961597 C-3.41381125,38.1914476 34.1413045,40.2354272 49.6157136,40.4082564 C53.907155,40.456209 58.1745771,40.0496109 62.3809502,39.1984522 C75.4664436,36.548072 104.111414,29.590949 100.093192,20.1332976 C94.9100356,7.92936086 79.3405502,16.4379503 79.3405502,16.4379503 C79.3405502,16.4379503 81.2941168,7.22505704 54.79887,1.13907287 C28.3056249,-4.94591229 28.4107091,15.3310445 28.4107091,15.3310445 C28.4107091,15.3310445 4.85281784,2.32589972 0.250126898,22.2961597",
    id: "Fill-165",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.756623,113.128375 L103.739854,110.731968 C104.000241,110.518926 104.125335,110.190212 104.070946,109.866073 L103.943132,109.09755 C103.901661,108.852485 103.761609,108.632907 103.552892,108.486522 L100.456125,106.316229 C100.089,106.058748 99.5865822,106.077699 99.2418926,106.362628 L98.8788467,106.66128 C98.686446,106.819429 98.5661106,107.043581 98.5409558,107.285378 L98.0786502,111.904358 L100.756623,113.128375",
    id: "Fill-50",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.081058,113.116987 C101.081058,113.116987 94.4042835,131.245948 90.6946035,137.82697 C86.9849234,144.408643 75.4290428,155.0869 75.4290428,155.0869 L70.0561787,140.434716 C70.0561787,140.434716 80.4426331,135.349708 85.5686183,129.926743 C90.6946035,124.503778 97.6189064,111.13035 97.6189064,111.13035 L101.081058,113.116987",
    id: "Fill-51",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7652703,102.139237 L38.1236034,98.8788071 C37.9820804,98.5902227 38.0033089,98.2500372 38.1776395,97.9805644 L38.5925592,97.3428757 C38.7244329,97.1390192 38.9322144,96.9956826 39.171517,96.9434444 L42.7121653,96.1668786 C43.131588,96.0751431 43.5600167,96.2802737 43.7465698,96.6644158 L43.9434154,97.0670324 C44.0476278,97.2810817 44.06371,97.5263466 43.9890888,97.7512258 L42.5693557,102.050687 L39.7652703,102.139237",
    id: "Fill-52",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0973782,103.068379 L44.8921445,100.096797 C45.2071309,99.5748662 44.9833593,98.8761636 44.4341018,98.6679503 L43.0763791,98.1523077 C42.7148009,98.015362 41.146431,99.4658686 41.146431,99.4658686 C41.146431,99.4658686 41.7987154,100.934541 43.1052528,99.4484011 C43.2338723,99.6943444 43.703727,99.8836928 43.703727,99.8836928 C43.703727,99.8836928 41.489635,100.575408 41.0329047,103.138249 L43.0973782,103.068379",
    id: "Fill-53",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0168536,219.88032 C21.0168536,219.88032 18.5882458,222.223581 17.0676762,227.568142 C16.7327206,228.744909 17.1802844,230.012837 15.0120383,230.012837 C15.0120383,227.517425 15.0120383,223.528103 15.0120383,223.528103 L16.053485,218.134109 L15.0120383,218.134109 L15.0120383,215.220762 C15.0120383,215.220762 20.3340318,214.409929 21.0168536,216.111201 C21.0168536,217.686643 21.0168536,219.88032 21.0168536,219.88032",
    id: "Fill-54",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0192613,219.693615 L20.602009,220.022712 C19.8661235,218.956206 19.8199704,217.556094 20.4827801,216.44193 L20.602009,216.241638 L24.0192613,215.02765 L24.0192613,219.693615",
    id: "Fill-55",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1222486,172.070112 C55.1222486,172.070112 50.9674687,184.14976 52.1583418,197.363849 C52.4776339,200.910442 49.9246249,204.06174 46.3573159,204.720783 C35.4628842,206.733081 23.0184587,214.56932 23.0184587,214.56932 L23.0184587,220.022712 C23.0184587,220.022712 56.6968033,217.047898 63.7199015,212.33821 C70.7436635,207.628521 74.0593889,176.89051 74.0593889,176.89051 L55.1222486,172.070112",
    id: "Fill-56",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1452581,138.228457 C78.737042,143.241654 75.2717727,174.068137 75.2717727,174.068137 L52.0938665,171.310682 L54.6062032,148.504391 C54.6062032,148.504391 44.055313,135.680379 42.0458396,126.303186 C40.0363662,116.925994 39.0312996,102.139237 39.0312996,102.139237 L43.3023379,102.139237 C43.3023379,102.139237 48.0749197,121.417065 51.0894598,126.303186 C54.1033399,131.189308 64.1513668,138.103358 64.1513668,138.103358 L71.1452581,138.228457",
    id: "Fill-57",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(73.058586, 141.100725)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78993894,32.6136109 C2.11388105,29.319932 3.93811975,8.7336245 0,0.544711286 C0.0921011876,0.364878374 0.17912093,0.183090755 0.264235131,0 C4.68191624,8.4892863 2.48673207,30.6439193 2.24155235,32.9674126 C2.09419045,32.8462209 1.94111193,32.7308932 1.78993894,32.6136109",
    id: "Fill-58",
    fill: "url(#linearGradient-14)",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.939372,237.005925 C101.939372,237.005925 104.286795,239.430189 109.640205,240.948039 C110.818419,241.282395 112.089886,240.835632 112.089886,243 C109.589398,243 105.592991,243 105.592991,243 L100.19006,241.960416 L100.19006,243 L97.2715379,243 C97.2715379,243 96.4586222,237.687525 98.1635586,237.005925 C99.7417985,237.005925 101.939372,237.005925 101.939372,237.005925",
    id: "Fill-61",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.750726,234.008887 L101.081058,237.419946 C100.01264,238.154498 98.6100201,238.200568 97.4938594,237.539599 L97.2932086,237.419946 L96.0770451,234.008887 L100.750726,234.008887",
    id: "Fill-62",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0529685,137.579593 L67.0115159,133.108625 L71.7087102,133.682351 L72.0577838,138.995467 C72.0284341,139.033716 71.9953377,139.068549 71.9609924,139.1027 C70.1488071,138.113022 68.093082,137.581642 66.0529685,137.579593",
    id: "Fill-63",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0513634,125.49858 L65.3652415,132.388968 C66.0481387,132.264515 66.5539885,132.949004 66.5127218,133.616766 C66.6065702,133.763968 66.6711326,133.933919 66.6990875,134.111899 C68.0096377,134.803079 70.3318874,135.618042 73.0501642,134.690001 C77.3012988,133.236717 73.4881236,125.116525 73.4881236,125.116525 L64.0513634,125.49858",
    id: "Fill-64",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8919002,130.90442 C62.7871091,130.392829 61.933907,129.396785 61.4971648,129.112492 C58.6820034,127.282567 60.7088655,125.377328 61.4336141,124.751748 C62.2361109,124.059674 61.839933,122.479438 62.8574205,121.423008 C64.4103566,119.810204 66.287807,120.994193 67.3749298,120.630515 C68.4620527,120.266837 68.948148,118.679817 70.6815952,119.241618 C72.4136902,119.804098 72.412338,121.108182 73.0079569,121.574993 C73.6028998,122.041803 74.3513109,120.416786 76.1712952,121.898639 C78.9391316,124.153307 74.3709169,125.922845 74.3709169,125.922845 C74.3709169,125.922845 71.9350316,127.357881 68.3261623,126.489396 C67.831278,126.369979 67.2877166,126.550461 67.0477112,127.000309 C66.3865134,128.235186 67.1923905,134.107637 67.1923905,134.107637 L65.918672,133.315145 C65.918672,133.315145 63.3719109,133.246616 62.8919002,130.90442",
    id: "Fill-65",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1880129,130.614083 C65.4656009,131.091177 66.0780372,131.252072 66.5560362,130.97501 C67.0340352,130.697326 67.1958578,130.085428 66.9176474,129.608954 C66.6400595,129.132481 66.0270008,128.970965 65.5496242,129.248028 C65.0716251,129.525711 64.9104249,130.136989 65.1880129,130.614083",
    id: "Fill-66",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1804227,173.829951 C75.1804227,173.829951 91.8547274,189.771082 93.3464213,193.668915 C94.8387713,197.567407 101.081058,234.008887 101.081058,234.008887 L96.337025,234.008887 C96.337025,234.008887 86.8200963,218.479477 83.9101779,206.285326 C82.8829163,201.983019 79.6614084,198.551582 75.4533096,197.242643 C49.1892627,189.071488 52.1411636,171.0711 52.1411636,171.0711 L75.1804227,173.829951",
    id: "Fill-67",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(65.052166, 136.105662)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-69"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-68",
    fill: "url(#linearGradient-17)",
    mask: "url(#mask-16)",
    points: "7.8997599 1.70017277 8.00642042 3.99605001 0 2.50131479 1.67835491 0 7.8997599 1.70017277"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.3056971,106.135287 L98.0786502,87.4245704 C98.0786502,87.4245704 91.5823072,85.5356765 87.539388,82.4615033 C86.0121218,81.2994129 85.1389254,79.4515963 85.0800061,77.5322256 C84.316704,52.5837201 68.6594119,49.4485935 68.6594119,49.4485935 C68.6594119,49.4485935 50.9379603,41.7664732 35.7619524,64.3994108 C19.5823313,88.5296827 42.7587779,99.8935229 42.7587779,99.8935229 C42.7587779,99.8935229 54.5121737,108.198428 70.4468496,100.024705 C72.7268257,98.8553269 75.4291667,98.8453888 77.7872604,99.8458202 C83.7102993,102.359487 87.3056971,106.135287 87.3056971,106.135287",
    id: "Fill-98",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6376231,87.1540494 L104.216728,90.9475545 C106.681616,92.3688986 107.770979,95.1432531 106.636741,97.1132204 L100.192912,108.304353 C99.0586733,110.27367 96.1131646,110.72207 93.6482766,109.300726 L87.0698221,105.507221 L97.6376231,87.1540494",
    id: "Fill-99",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-100",
    fill: "#21837F",
    points: "105.775367 98.143187 108.086676 101.151128 104.019116 108.133312 100.080255 107.921117 105.775367 98.143187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8925184,70.6779106 C68.1880049,73.3525494 67.468875,75.9948125 65.9029745,78.2518694 L61.8500557,75.9062745 C61.0967128,75.4701921 60.5407523,74.7579241 60.3209999,73.91351 C59.9301827,72.4050613 59.9170239,70.1182715 62.1954749,68.6197337 C63.7863771,67.7680515 66.0115349,68.8589183 66.8925184,70.6779106 Z M61.5697727,82.9232371 C59.9433416,84.3761844 57.2740734,86.2163201 55.3528846,85.4194786 C54.8837724,85.224563 54.5475644,84.7739445 54.4436096,84.2744319 C53.440907,79.4894184 59.0491992,81.5053085 59.6749015,81.8905146 C60.3256055,82.181897 60.9499919,82.5512456 61.5697727,82.9232371 Z M67.7340254,69.7125827 C64.102189,63.8314166 57.4892203,69.2976437 59.1965781,74.6832615 C59.5064685,75.6578397 60.2374414,76.4381629 61.1105296,76.9667477 C62.65406,77.901682 65.100944,79.2885562 65.100944,79.2885562 C64.3627338,80.1798822 63.4712232,81.1306741 62.7474877,81.8231201 C61.262514,80.9099899 59.6939818,80.0239497 58.1451878,79.7101025 C51.2624631,78.316621 51.4499764,88.3352842 58.0583395,86.3920745 C59.6051597,85.9368309 61.184219,84.8611609 62.6310321,83.552253 C71.790234,88.7489018 80.9500938,93.9455506 90.1099536,99.1421995 L90.8409265,97.8676495 C85.2115801,94.6736761 79.5815757,91.4797028 73.9515714,88.2850687 C71.0303117,86.6279555 68.108394,84.9701815 65.1871343,83.3130684 C64.7285492,83.0527404 64.2508838,82.7573936 63.7633492,82.4534574 C64.5443256,81.6381154 65.2562182,80.784451 65.8779728,79.9347511 L92.3430066,95.2498335 L93.0746374,93.9746228 L66.7102686,78.7190061 C66.8701484,78.4685891 67.0385814,78.2128862 67.1754332,77.9737016 C68.5610577,75.5468369 69.297952,72.2451644 67.7340254,69.7125827 L67.7340254,69.7125827 Z",
    id: "Fill-101",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9743003,85.9627619 C16.8115368,85.3811657 16.1919856,85.0376388 15.5881857,85.1936152 L0.838403124,89.0096691 C0.23460318,89.1656455 -0.123082656,89.7623973 0.039024503,90.343362 C0.201787966,90.9249581 0.821339212,91.2684851 1.42513916,91.1125087 L16.1762343,87.2964548 C16.7800342,87.1404784 17.1370638,86.5437266 16.9743003,85.9627619",
    id: "Fill-102",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2260697,44.15751 C40.6433706,44.3193294 40.0461198,43.9629337 39.8892149,43.3602057 L36.0665567,28.6359547 C35.9102845,28.0332268 36.2544629,27.4147755 36.8365294,27.252301 C37.4179632,27.0904816 38.0164793,27.4468773 38.1727515,28.0496053 L41.9960424,42.7738562 C42.1523146,43.3765842 41.8081362,43.9950355 41.2260697,44.15751",
    id: "Fill-103",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8653256,59.6080202 C28.1887891,59.0604034 27.996881,58.3622913 27.4367534,58.0467155 L13.7631295,50.3436156 C13.2023238,50.0280398 12.4889409,50.2163245 12.1661555,50.7632784 C11.8433701,51.3108953 12.0359563,52.0083444 12.5954058,52.3239202 L26.2697078,60.0276831 C26.8291573,60.3432589 27.5432183,60.1549741 27.8653256,59.6080202",
    id: "Fill-104",
    fill: "#FACB57"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeas);
export default __webpack_public_path__ + "static/media/ideas.084e70dd39db323653689763f06ef324.svg";
export { ForwardRef as ReactComponent };